/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import errorMsg from "../json/errMsg.json";
import { username, password } from "./common.js";
import { DEFAULT_LANGUAGE } from "../../config";

export const validLogin = {
  username: (err) => {
    return {
      ...username(err),
      ...{
        msgOnError:
          err === "" ? errorMsg[DEFAULT_LANGUAGE].loginErr.loginEmailErr : err,
      },
    };
  },
  password: (err) => {
    return {
      ...password(err),
      ...{
        msgOnError:
          err === "" ? errorMsg[DEFAULT_LANGUAGE].pwErr.passwdErr : err,
      },
    };
  },
};
